import { useState } from 'react'
import { formatCurrency } from 'lib/helpers'
import { motion } from 'motion/react'
import { useHasTouch } from 'lib/hooks/useHasTouch'

import Link from 'next/link'
import { Tag } from 'components/Global/Tag'
import { ResponsiveImage } from 'components/Global/ResponsiveImage'
import { AutoScrollCarousel } from 'components/AutoScrollCarousel'
import { DonationTag } from 'components/Global/DonationTag'
import { PortableText } from '@portabletext/react'
import { useRouter } from 'next/router'

export const ScrollingCarousel = ({ tag, cause, collection, products }) => {
  const [hovered, setHovered] = useState(false)
  const touch = useHasTouch()
  const router = useRouter()

  return (
    <div className="relative overflow-hidden">
      {cause ? (
        <button
          className="absolute left-0 top-0 z-[1] hidden max-w-[300px] p-20 text-left md:block"
          onMouseEnter={() => !touch && setHovered(true)}
          onMouseLeave={() => !touch && setHovered(false)}
          onClick={() => {
            touch && setHovered(!hovered)
          }}
        >
          <div className="inline-flex flex-col rounded-12 bg-white p-10 text-12 leading-100 text-midGray shadow-md">
            <div>
              <Tag>{tag}</Tag>
            </div>
            <div className="pb-4 pt-10 text-darkGray">{cause.title}</div>
            <div>{cause.subtitle}</div>
            <div className="pt-20">
              <DonationTag {...cause} />
            </div>
            <motion.div
              className="overflow-hidden"
              initial={{ height: 0 }}
              animate={{ height: hovered ? 'auto' : 0 }}
              transition={{
                duration: 0.5,
                ease: [0.7, 0, 0.1, 1],
              }}
            >
              <div className="py-24 leading-120 text-[#AAAAAA]">
                <PortableText value={cause.description} />
              </div>
              <Link
                scroll={false}
                href={`/collections/${collection.slug}`}
                className="pb-10 text-[#AAAAAA] underline"
              >
                Shop Now
              </Link>
            </motion.div>
          </div>
        </button>
      ) : null}
      <AutoScrollCarousel className="h-[80vh] py-20 md:h-screen md:py-0">
        {products.map((product) => {
          return (
            <button
              key={product._id}
              className="group relative inline-flex aspect-[2/3] h-full w-auto cursor-grab select-none snap-start flex-col items-end items-center justify-end whitespace-normal active:cursor-grabbing md:absolute "
              data-carousel-item
              onClick={() =>
                router.push(`/products/${product.slug}`, undefined, {
                  scroll: false,
                })
              }
            >
              <div className="relative w-full flex-1">
                <ResponsiveImage
                  className="pointer-events-none"
                  src={`${product.imgUrl}&width=1000`}
                  alt={product.title}
                  sizes="(min-width: 768px) 25vw, 100vw"
                />
              </div>
              <Link
                scroll={false}
                href={`/products/${product.slug}`}
                className="ease mb-[20px] flex w-[90%] cursor-pointer justify-between gap-20 rounded-8 bg-white px-16 py-12 text-12 leading-100 text-midGray transition-opacity duration-300 group-hover:opacity-100 md:mb-[50px] md:min-w-[350px] md:max-w-[425px] md:opacity-30"
              >
                <div className="flex-1">{product.title}</div>
                <div>{formatCurrency(product.price)}</div>
              </Link>
            </button>
          )
        })}
      </AutoScrollCarousel>
    </div>
  )
}
